import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../../context/CartContext';
import styles from './Navbar.module.css';
import logo from '../../assets/logo.jpg';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { toggleCart, getCartItemsCount } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home', gujarati: 'હોમ' },
    { path: '/products', label: 'Products', gujarati: 'ઉત્પાદનો' },
    { path: '/process', label: 'Our Process', gujarati: 'પ્રક્રિયા' },
    { path: '/about', label: 'About Us', gujarati: 'અમારા વિશે' },
    { path: '/gallery', label: 'Gallery', gujarati: 'ગેલેરી' },
    { path: '/contact', label: 'Contact', gujarati: 'સંપર્ક' },
  ];

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.navContainer}>
        <Link to="/" className={styles.logo}>
          <img src={logo} alt="Bahariya Farm Logo" className={styles.logoImage} />
          <div className={styles.logoText}>
            <span className={styles.brandName}>Bahariya Farm</span>
            <span className={styles.brandTagline}>Pure Bilona Ghee</span>
          </div>
        </Link>

        <div className={`${styles.navLinks} ${menuOpen ? styles.active : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`${styles.navLink} ${location.pathname === link.path ? styles.activeLink : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              <span>{link.label}</span>
              <span className={styles.gujaratiLabel}>{link.gujarati}</span>
            </Link>
          ))}
        </div>

        <div className={styles.navActions}>
          <button className={styles.cartButton} onClick={toggleCart}>
            <FaShoppingCart />
            {getCartItemsCount() > 0 && (
              <span className={styles.cartBadge}>{getCartItemsCount()}</span>
            )}
          </button>

          <div className={styles.menuToggle} onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
